<template>
  <UAVViewer
    :project-id="projectId"
    :use-public-api="usePublicApi"
    controls-position="side-left"
    :show-subtitle="true"
    :show-photo-btn="true"
    :enable-annotation="true"
    :show-sandbox="true"
    :use-icons="true"
    :float-header="true"
  />
</template>

<script>
import UAVViewer from '@/components/uav/viewer.vue';

export default {
  name: 'UAVProjectView',
  routerOption: {
    as_object: true,
  },
  metaInfo:{
    title:"全景照片"
  },
  components: {
    UAVViewer,
  },
  computed: {
    projectId() {
      return this.$route.params.id;
    },
    usePublicApi() {
      try {
        const session = this.$store.getters['session/session'];
        return !(session && session.id);
      } catch (error) {
        return true;
      }
    },
  },
  mounted() {
    // 设置viewport防止横竖屏切换时异常缩放
    this.setupViewport();
  },
  methods: {
    setupViewport() {
      let viewport = document.querySelector('meta[name=viewport]');
      if (!viewport) {
        viewport = document.createElement('meta');
        viewport.name = 'viewport';
        document.head.appendChild(viewport);
      }
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    },
  },
};
</script>
